import { Size } from '../types'

export const sizeToDimension: Record<Size, number> = {
  sm: 32,
  md: 40,
  lg: 48,
}
